import { createContext } from 'react';

export default createContext<{ showResults?: boolean } | undefined>({});
